module.exports = __webpack_public_path__ + "static/assets/d71c0379472f709318ef81ff0dccf7d5.svg";